import { useState } from 'react'

import { EMPTY_STRING } from '../../../constants/common'
import { mockApiCall } from '../../../utils/mock'
import {
  FileAttachedItemsModal,
  FileAttachTag,
  FilePreview,
  FileUploadPlaceholder,
} from '../../File'
import { Container } from '../Container'

import { FILE_PREVIEW_TYPES } from './Files.constants'

import * as styles from './Files.module.css'

function Files() {
  const [modal, setModal] = useState(null)

  function getItems() {
    return mockApiCall({
      value: {
        data: [
          {
            created: '2024-07-18T15:42:47.919034+02:00',
            filename: 'first_items.png',
            id: 0,
            mime_type: 'image/png',
          },
        ],
      },
    })
  }

  function getItemsFromResponse(data) {
    return { items: data }
  }

  return (
    <>
      {FILE_PREVIEW_TYPES.map(item => (
        <Container
          key={item.type + item.size}
          label={`File attach item ${item.type} ${item.uploading ? ' loader' : EMPTY_STRING} ${
            item.error ? ' error' : EMPTY_STRING
          } `}
          style={{ width: '420px' }}
        >
          <FileAttachTag {...item} file={item} onRemove={() => {}} />
        </Container>
      ))}
      {FILE_PREVIEW_TYPES.map(item => (
        <Container
          key={item.type + item.size}
          label={`File ${item.type} ${item.uploading ? ' loader' : EMPTY_STRING} ${
            item.error ? ' error' : EMPTY_STRING
          } preview`}
        >
          <FilePreview className={styles.file} file={item} />
        </Container>
      ))}
      <Container label='Image file selected preview'>
        <FilePreview
          isSelected
          className={styles.file}
          file={{
            name: 'testFileWith Very VeryVeryLongName.JPG',
            size: 333,
            type: 'image/jpeg',
          }}
        />
      </Container>
      <Container label='Upload'>
        <FileUploadPlaceholder
          className={styles.uploadPlaceholder}
          text='Click to upload'
        />
      </Container>
      <Container label='Upload, disabled'>
        <FileUploadPlaceholder
          disabled
          className={styles.uploadPlaceholder}
          text='Click to upload'
        />
      </Container>
      <Container label='Upload, loading'>
        <FileUploadPlaceholder
          loading
          className={styles.uploadPlaceholder}
          text='Loading...'
        />
      </Container>
      <Container label='Files attached items modal'>
        <div
          onClick={() =>
            setModal(
              <FileAttachedItemsModal
                getData={getItems}
                getItemsFromResponse={getItemsFromResponse}
                onClose={() => {
                  setModal(null)
                }}
              />
            )
          }
        >
          Click for open attached files
        </div>
      </Container>
      {modal}
    </>
  )
}

export default Files
